import React, { useEffect, useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';

/**
 * Simple hover/click accessible dropdown for the desktop toolbar nav.
 * items: [{ to: string, label: string }]
 */
function NavDropdown({ label, items }) {
    const [open, setOpen] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        function handleClickOutside(event) {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setOpen(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <li
            className="nav-dropdown"
            ref={containerRef}
            onMouseEnter={() => setOpen(true)}
            onMouseLeave={() => setOpen(false)}
        >
            <button
                type="button"
                className="nav-dropdown-toggle"
                aria-expanded={open}
                onClick={() => setOpen((prevOpen) => !prevOpen)}
            >
                {label} <span className="nav-dropdown-caret">▾</span>
            </button>
            {open && (
                <ul className="nav-dropdown-menu">
                    {items.map((item) => (
                        <li key={item.to}>
                            <NavLink
                                activeStyle={{ color: '#27C492' }}
                                to={item.to}
                                onClick={() => setOpen(false)}
                            >
                                {item.label}
                            </NavLink>
                        </li>
                    ))}
                </ul>
            )}
        </li>
    );
}

export default NavDropdown;
